"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentSessionURL = void 0;

const _getCurrentSessionURLNamespace = namespace => {
  var _window$namespace, _window$namespace2;

  if (!namespace) {
    return null;
  }

  return ((_window$namespace = window[namespace]) === null || _window$namespace === void 0 ? void 0 : _window$namespace.getCurrentSessionURL) && ((_window$namespace2 = window[namespace]) === null || _window$namespace2 === void 0 ? void 0 : _window$namespace2.getCurrentSessionURL());
};

const getCurrentSessionURL = () => {
  const namespace = window._fs_namespace;
  return _getCurrentSessionURLNamespace('FS') || _getCurrentSessionURLNamespace(namespace);
};

exports.getCurrentSessionURL = getCurrentSessionURL;